const initialState = {
    allcustomerDetails: [], 
    selectedCustomer: null, 
    client_customer_id: null,
    selected_customer_details: null,
    error: null,
    loading: false,
    policy_listing: [],
  };
  
  const customerDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'START_LOADING': {
        return { ...state, loading: true };
      }
  
      case 'STOP_LOADING': {
        return { ...state, loading: false };
      }
  
      case 'GET_CUSTOMER_DETAILS_SUCCESS': {
        return {
          ...state,
          selectedCustomer: action.payload, 
          error: null,
        };
      }
      case 'CLEAR_GET_CUSTOMER_DETAILS_SUCCESS': {
        return {
          ...state,
          selectedCustomer: [], 
          error: null,
        };
      }
  
      case 'GET_CUSTOMER_DETAILS_FAILURE': {
        return { ...state, error: action.payload };
      }
  
      case 'UPDATE_CUSTOMER_SUCCESS': {
        const updatedCustomer = action.payload;
        return {
          ...state,
          allcustomerDetails: state.allcustomerDetails.map(customer =>
            customer.id === updatedCustomer.id ? updatedCustomer : customer
          ),
          error: null,
        };
      }
      case 'GET_CUSTOMER_ID_SUCCESS':        
        return { ...state, client_customer_id: action.payload, error: null };  

      case 'GET_SELECTED_CUSTOMER_DETAILS_SUCCESS':        
        return { ...state, selected_customer_details: action.payload, error: null };  
      case 'GET_POLICY_LISTING_SUCCESS':        
      return { ...state, policy_listing: action.payload, error: null };  
      case 'UPDATE_CUSTOMER_FAILURE': {
        return { ...state, error: action.payload };
      }
  
      default:
        return state;
    }
  };
  
  export default customerDetailsReducer;
  